import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    VisitorIqFilterSettingsUpdateInput,
    UpdateVisitorIqFilterSettings as UpdateVisitorIqFilterSettingsMutation,
    UpdateVisitorIqFilterSettingsVariables as UpdateVisitorIqFilterSettingsMutationVariables,
} from 'nutshell-graphql-types';

import UPDATE_VISITOR_IQ_FILTER_SETTINGS from '../mutations/update-visitor-iq-filter-settings.graphql';
import GET_VISITOR_IQ_FILTER_SETTINGS from '../queries/get-visitor-iq-filter-settings.graphql';

export function useUpdateVisitorIqFilterSettings(): {
    updateVisitorIqFilterSettings: (input: VisitorIqFilterSettingsUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [updateVisitorIqFilterSettings, {loading, error}] = useMutation<
        UpdateVisitorIqFilterSettingsMutation,
        UpdateVisitorIqFilterSettingsMutationVariables
    >(UPDATE_VISITOR_IQ_FILTER_SETTINGS);

    return {
        updateVisitorIqFilterSettings: (input: VisitorIqFilterSettingsUpdateInput) =>
            updateVisitorIqFilterSettings({
                variables: {input},
                update: (proxy, mutationResults) => {
                    const updatedSettings =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.visitorIqFilterSettingsUpdate;

                    if (updatedSettings) {
                        proxy.writeQuery({
                            query: GET_VISITOR_IQ_FILTER_SETTINGS,
                            variables: {},
                            data: {
                                visitorIqFilterSettings: updatedSettings,
                            },
                        });
                    }
                },
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
